import { Stack, styled } from '@mui/material'
import { BadgeCheckIcon } from '$common/icons/badge-check'

const BadgeContainer = styled(Stack)`
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid white;
  background-color: ${({ theme }) => theme.palette.success.main};
`

export function SelectedBadge() {
  return (
    <BadgeContainer>
      <BadgeCheckIcon />
    </BadgeContainer>
  )
}
